@defer (when isLoaded()) {
  @if (redirectUrl()) {
    <a [routerLink]="redirectUrl()">
      @if (displayName()) {
        {{ displayName() }}
      } @else {
        <glxy-blank-value></glxy-blank-value>
      }
    </a>
  } @else {
    <div>
      @if (displayName()) {
        {{ displayName() }}
      } @else {
        <glxy-blank-value></glxy-blank-value>
      }
    </div>
  }
} @placeholder {
  <div class="stencil-shimmer"></div>
}
